export default __webpack_public_path__ + "static/media/fully-digital-experience.3a258a9b.png";